// Create a new meet_rooms row + auto-add the creator as an owning member.
// camelCase API at the boundary; snake_case at the row write — same boundary
// chat's createChannel uses.
//
// migrated 2026-04-27 to SDK route workspaceProject.meet.rooms (create) +
// workspaceProject.meet.members (create)
import { getSDK } from '../../../shared/functions/sdk.js'
import { rowToRoom } from './meetUtils.js'

export const createRoom = async function ({
  name,
  kind = 'room',
  isPrivate = false,
  transcribeEnabled = false,
  calendarEventId = null,
  chatChannelId = null
}) {
  const root = this.state.root
  const me = root.currentUserId
  if (!me) {
    console.error('[createRoom] no currentUserId — meet requires real auth')
    return null
  }
  const sdk = getSDK()

  try {
    const result = await sdk.execute('workspaceProject.meet.rooms', 'create', {
      payload: {
        name: name || 'Untitled call',
        kind,
        is_private: isPrivate,
        transcribe_enabled: transcribeEnabled,
        calendar_event_id: calendarEventId,
        chat_channel_id: chatChannelId,
        created_by: me
      }
    })
    const row = result?.data || result
    if (!row?.id) throw new Error('createRoom: empty response')

    const room = rowToRoom(row)

    // Auto-add the creator as the owning member. Other members can self-join
    // via the shareable URL (the meet_members_insert RLS policy allows
    // user_id = auth.uid() inserts).
    try {
      await sdk.execute('workspaceProject.meet.members', 'create', {
        roomId: room.id,
        payload: { user_id: me, role: 'owner' }
      })
    } catch (memErr) {
      console.warn('[createRoom] member insert failed', memErr?.message || memErr)
    }

    // Optimistic state merge — realtime will deliver the same row but the
    // user shouldn't have to wait for the round trip.
    const existing = root.rooms || []
    if (!existing.some((r) => r.id === room.id)) {
      root.update({
        rooms: [room, ...existing],
        activeRoomId: room.id,
        showNewRoom: false
      })
    }

    return room.id
  } catch (err) {
    console.error('[createRoom]', err?.message || err)
    return null
  }
}
